export default {
  lookups: {},
  groups: [],
  timeZones: [],
  countries: [],
  stateProvinces: [],
  languages: [],
  calibrateReady: [],
  calibratePreCheckList: [],
  calibrateService: [],
  calibrateActionType: [],
  calibrateVerify: []
}



// WEBPACK FOOTER //
// ./src/store/modules/lookups/state.js